/**
 * Created by chai on 17/2/16.
 */
import { requestParamHandler } from '@/utils/requestParam.js'

export default {
  // 检测登录用户
  CheckUserLogin: (login) => `/api/checklogin/${login}`,
  // 重置密码
  ResetPasswordByPhone: '/web/user/reset_password',
  // 重置密码-邮箱
  ResetPasswordByEmail: '/web/user/reset_password/by_email',
  // 获取手机验证码
  getPhoneCode: (phone) => `/web/user/sms/validate_code_phone/${phone}`,
  getBusinessPhoneCode: (phone, type) =>
    `/web/user/sms/validate_code_phone/${phone}?source=${type}`,
  // 获取邮箱验证码
  getEmailCode: (email) => `/web/user/sms/validate_code_email/${email}`,
  // 注册用户-邮箱
  RegisterByEmail: (params) =>
    requestParamHandler('/web/user/register/by_email', params),
  // 注册用户-手机
  RegisterByPhone: (params) =>
    requestParamHandler('/web/user/register', params),
  // 获取活动信息【新版】
  fetchEventData: (hash) => `/event/detail/${hash}`,
  // 获取活动信息【旧版】
  GetEventData: (eventid) => `/api/graph/node/${eventid}`,
  // 第三方登录 授权配置
  GetAuthConfig: `/web/user/auth/sns/config`,
  // 第三方登录 code获取授权信息
  GetAuthCode: (gi_guest) =>
    `/web/user/auth/sns/code${gi_guest ? '?gi_guest=' + gi_guest : ''}`,
  // 第三方登录静默授权
  GetSilentCode: `/web/user/auth/sns/silent`,
  // 验证用户名是否注册
  CheckUser: `/web/user/check_username`,
  // 用户登录（ 邮箱｜手机号 ）
  UserLogin: (params) => requestParamHandler('/web/user/login', params),
  // 用户(手机验证码)登录
  VerificationCodeLogin: (params) =>
    requestParamHandler('/web/user/login/by_verification_code', params),
  // 获取用户信息
  GetUserInfo: `/web/user/info`,
  // 获取用户卡片信息
  getCardUser: `/web/user/center/card/info`,
  // 上传头像
  uploadAvator: `/web/user/upload_avatar`,
  // 用户地域
  GetUserRegional: `/web/user/regional`,
  // 用户token刷新（主动）
  UserRefreshToken: `/web/user/refresh`,
  // 绑定手机号，补全信息
  BindPhone: `/web/user/bind_phone`,
  BindEmail: `/web/user/bind_email`,
  // 游客绑定为平台用户
  BindUser: `/web/user/auth/sns/bind_user`,
  // 伪协议
  checkProto: `/web/user/regional_check`,
  // 白名单
  getWhiteList: `/web/user/auth/sns/white-list`,
  // 第三方登录(Aia)
  ThirdLogin: '/web/user/third-login',
  // Aia 机构信息列表
  AiaOrganList: '/web/user/aia-subsidiary-organ',
  // 获取用户信息(Aia, 代理角色处理)
  UserExtraInfo: (params) => `/web/user/extra-info?source=${params.source}`,
  // Aia 保存代理信息
  SaveExtraInfo: (params) =>
    `/web/user/save-extra-info?source=${params.source}`,
  // 保时捷hr员工绑定信息
  staffInfo: `/web/game/player/porsche-hr/staff-check`,
  isInMemberCard: '/web/game/player/member-card',
}
